import { render, staticRenderFns } from "./TestimonialsListing.vue?vue&type=template&id=5629def4&"
import script from "./TestimonialsListing.vue?vue&type=script&lang=ts&"
export * from "./TestimonialsListing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports